import { j as e } from "../../../jsx-runtime-ClSzPYp4.js";
import { styled as t } from "styled-components";
import r from "../Loadable.mjs";
import { BasePostOfficeLogo as p, DefaultLogoWrapper as f } from "../LogoTemplate.mjs";
const i = (o) => /* @__PURE__ */ e.jsx(f, {
  flexDirection: [
    "row",
    null,
    "column"
  ],
  width: [
    "20rem",
    null,
    "14rem"
  ],
  ...o
}), n = /* @__PURE__ */ t.div.withConfig({
  componentId: "sc-556a4fb5-0"
})([
  "",
  ""
], ({ theme: o }) => o.components.logo.postOffice.postOfficeWrapperVariant1), s = /* @__PURE__ */ t.div.withConfig({
  componentId: "sc-556a4fb5-1"
})([
  "",
  ""
], ({ theme: o }) => o.components.logo.postOffice.capitalOneWrapperVariant1), a = (o) => /* @__PURE__ */ e.jsx(p, {
  LogoWrapper: i,
  PostOfficeLogoWrapper: n,
  CapitalOneLogoWrapper: s,
  ...o
}), d = (o) => /* @__PURE__ */ e.jsx(r, {
  RenderedLogo: a,
  ...o
});
export {
  d as default
};
